/**
 * Global AdminTopNav component.
 */

// import primary libararies
import React from 'react';
import PropTypes from 'prop-types';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { NavLink, withRouter } from 'react-router-dom';

// import third-party libraries
import classNames from 'classnames';

// import components
import CloseWrapper from '../../../global/components/helpers/CloseWrapper.js.jsx';

const MoreDropdown = ({close, isOpen}) => {
  return(
    <TransitionGroup >
      { isOpen ?
          <CSSTransition
            classNames="dropdown-anim"
            timeout={250}
          >
          <ul className="dropMenu">
            <div>
              <li><a href={`${window.hubUrl}/super/organizations`} >Organizations</a></li>
              <li><NavLink to="/admin/site-locations" onClick={()=> close()}>Locations</NavLink></li>
              <li><NavLink to="/admin/certificate-templates" onClick={()=> close()}>Certificate Templates</NavLink></li>
              <li><NavLink to="/admin/authoring/evaluations" activeClassName="active">Evaluations</NavLink></li>
              <li><a href={`${window.authoringUrl}/metrics`}>Metrics</a></li>
              <li role="separator" className="-divider"/>
              <li><NavLink to="/admin/users" onClick={()=> close()}>Users</NavLink></li>
            </div>
          </ul>
          </CSSTransition>
        :
          null
      }
    </TransitionGroup>
  )
}

MoreDropdown.propTypes = {
  close: PropTypes.func.isRequired
  , isOpen: PropTypes.bool.isRequired
}

export default withRouter(MoreDropdown);



// WEBPACK FOOTER //
// modules/admin/components/MoreDropdown.js.jsx